<template>
  <div
    class="Row"
    :style="style"
  >
    <template v-for="(field,index) in fields">
      <template v-if="!field.props.hidden">
        <Instruction
          v-if="field.props.type === 'instruction'"
          v-bind="field.props"
          :key="`fieldInstruction_${index}`"
        />
        <FieldValue
          v-else-if="viewer || field.readonly || field.viewer"
          v-bind="field.props"
          :key="`fieldValue_${index}`"
          :name="name({ name: field.name })"
        />
        <FormField
          v-else
          v-bind="{...$props,...field.props}"
          :key="`field_${index}`"
          :name="name({ name: field.name })"
          :planned-date-alert="plannedDateAlert"
          :locked="field.props.locked"
          @blur="handleBlur({ name: field.name, fieldPath: field.field && field.field.path })"
          @change="($event) => $emit('change', $event)"
          @update="value => $emit('update', { name: field.name, value })"
          @input="value => handleInput({ name: field.name, value, fieldPath: field.field && field.field.path })"
        />
      </template>
    </template>
  </div>
</template>

<script>

import Instruction from '@/components/form/Instruction'
import FormField from '@/components/form/FormField'
import FieldValue from '@/components/form/FieldValue'

export default {
  name: 'Row',
  components: { FormField, FieldValue, Instruction },
  props: {
    uuid: {
      type: String,
      default: '',
    },
    fields: {
      type: Array,
      required: true,
    },
    plannedDateAlert: {
      type: String,
      default: '',
    },
    selectDisabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * CSS Grid "grid-template-columns" value
     */
    columns: {
      type: String,
      required: true,
    },
    /**
     *
     */
    path: {
      type: String,
      default: '',
    },

    /**
     * Viewer Mode
     */
    viewer: {
      type: Boolean,
      default: false,
    },

    /**
     * Bootstrap sizes (sm, lg or empty for regular)
     */
    size: {
      type: String,
      default: 'sm',
    },
    debounce: {
      type: [Number, String],
      default: '0',
    },
    canReset: {
      type: Boolean,
      default: true,
    },
    className: {
      type: String,
      default: '',
    },
    groupClass: {
      type: String,
      default: '',
    },
    info: {
      type: [String, Object],
      default: '',
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      return {
        'grid-template-columns': this.columns,
      }
    },
  },
  methods: {
    name({ name }) {
      return this.path === '' ? name : `${this.path}.${name}`
    },
    fieldName({ name, fieldPath }) {
      if (fieldPath == null) return this.name({ name })
      return fieldPath === '' ? name : `${fieldPath}.${name}`
    },
    handleBlur({ name, fieldPath }) {
      this.$emit('blur', {
        name: this.fieldName({ name, fieldPath }),
      })
    },
    handleInput({ name, value, fieldPath }) {
      this.$emit('input', {
        value,
        name: this.fieldName({ name, fieldPath }),
      })
    },
  },
}
</script>

<style>
.Row {
  display: grid;
  column-gap: 1em;
}
</style>
